import Popup from "components/Popup/Popup";
import PopupSubmitSuccess from "components/Popup/PopupSubmitSuccess/PopupSubmitSuccess";

import { createRef, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

import jobsData from "data/jobs.json";

import JobDetail from "./components/JobDetail";

import "./DetailJob.scss";

function DetailJob() {
  const { slug } = useParams();
  const navigate = useNavigate();

  const form = createRef();

  const [showPopup, setShowPopup] = useState(false);
  const [isError, setIsError] = useState(0);

  /**
   * Find current job by ID.
   *
   * The old application used:
   *
   * 1 = Administrator
   * 2 = FrontEnd
   * 3 = BackEnd
   * 4 = Tester
   * 5 = Designer
   *
   * We keep the same URL structure so existing links
   * do not need to change.
   */

  const job = Object.values(jobsData.jobs)?.find((item) => item.slug === slug);

  useEffect(() => {
    if (!job) {
      navigate("/not-found", { replace: true });
    }
  }, [job, navigate]);

  const handleBackPage = () => {
    navigate("/jobs");
  };

  const sendEmail = (event) => {
    event.preventDefault();

    const name = event.target.user_name.value;
    const phone = event.target.user_phone.value;
    const email = event.target.user_email.value;

    setIsError(0);

    if (!name.trim()) {
      setIsError(1);
      return;
    }

    if (!phone.trim()) {
      setIsError(2);
      return;
    }

    if (!email.trim()) {
      setIsError(3);
      return;
    }

    /**
     * EmailJS integration can be enabled here later.
     *
     * For now we keep the original behaviour:
     * show success notification + reset form.
     */

    toast.success("Sent successfully!");

    setShowPopup(true);

    event.target.reset();
  };

  if (!job) {
    return null;
  }

  return (
    <div className="detail-jobs">
      <div className="detail-wrapper">
        {/* BACK */}
        <div className="top-detail">
          <button type="button" className="back-page" onClick={handleBackPage}>
            <img
              src={require("assets/images/icons/back.png")}
              className="icon-back"
              alt=""
            />

            <div className="text-back">
              Back to <b>Jobs Listing</b>
            </div>
          </button>

          <div className="line" />
        </div>

        {/* JOB DETAIL */}
        <div className="content-detail-wrapper">
          <JobDetail job={job} company={jobsData.company} />

          {/* APPLY */}
          <div className="apply-job">
            <div className="title-form">
              <b>Let's join</b> the development together
            </div>

            <form
              encType="multipart/form-data"
              className="form-contact"
              ref={form}
              onSubmit={sendEmail}
            >
              <div className="info-user">
                <div className="input-name">
                  <input
                    type="text"
                    className="input-item"
                    placeholder="Enter your name"
                    name="user_name"
                  />

                  {isError === 1 && <span className="error">*Required</span>}
                </div>

                <div className="input-phone">
                  <input
                    type="tel"
                    className="input-item"
                    placeholder="Enter your phone number"
                    name="user_phone"
                  />

                  {isError === 2 && <span className="error">*Required</span>}
                </div>
              </div>

              <div className="input-email">
                <input
                  type="email"
                  className="input-item"
                  placeholder="Enter your email"
                  name="user_email"
                />

                {isError === 3 && <span className="error">*Required</span>}
              </div>

              <textarea
                rows={5}
                className="input-detail"
                placeholder="Online Profile To Portfolio"
                name="message"
              />

              <button type="submit" className="send-btn">
                SEND US
              </button>
            </form>
          </div>
        </div>
      </div>

      {/* SUCCESS POPUP */}
      {showPopup && (
        <Popup isShow={showPopup} onClose={() => setShowPopup(false)} center>
          <PopupSubmitSuccess
            onClose={() => setShowPopup(false)}
            content="You have submitted successfully"
          />
        </Popup>
      )}
    </div>
  );
}

export default DetailJob;
